module.exports = __webpack_public_path__ + "img/symbol_6.d87611bb.png";